import { Badge } from "@chakra-ui/react";

interface IOrderStatus {
    data : string;
 }
const OrderStatus = ({data}: IOrderStatus) => {
    

 const changeColor = () => {
    let color = ""
    switch (data) {

        case "0" :
         color = "gray";
         break;
        case "1":
           color = "purple"; 
        break;
        case "2":
            color = "blue"; 
         break;

         case "3":
            color = "green"; 
         break;

         case "4":
            color = "cyan"; 
         break;
           
         case "5":
            color = "yellow"; 
         break;
                    
         case "6":
            color = "black"; 
         break;
         case "7":
            color = "red"; 
         break;
         case "8":
            color = "orange"; 
         break;
    
    
        default:
            break;
    }

    return color;
 }

 const changeTextColor = () => {
   let color = ""
   switch (data) {

       case "0" :
        color = "white";
        break;
       case "1":
          color = "white"; 
       break;
       case "2":
           color = "white"; 
        break;

        case "3":
           color = "white"; 
        break;

        case "4":
           color = "black"; 
        break;
          
        case "5":
           color = "black"; 
        break;
                   
        case "6":
           color = "white"; 
        break;
        case "7":
           color = "white"; 
        break;

        case "8":
         color = "white"; 
         break;

   
   
       default:
           break;
   }

   return color;
}


 const changeText = () => {
    let text = ""
    switch (data) {

        case "0" :
            text = "RASCUNHO";
         break;
        case "1":
            text = "EM ABERTO"; 
        break;
        case "2":
            text = "EM NEGOCIAÇÃO"; 
         break;

         case "3":
            text = "APROVADO"; 
         break;

         case "4":
            text = "REVISÃO"; 
         break;
           
         case "5":
            text = "EM PRODUÇÃO"; 
         break;
         case "6":
            text = "CONCLUÍDO"; 
         break;
         case "7":
            text = "DECLINADO"; 
         break;

         case "8":
            text = "VENCIDO"; 
         break;
    
        default:
            break;
    }
    return text;
 }

 return(
    <Badge  backgroundColor={changeColor()} color={changeTextColor()} >
        {changeText()}
    </Badge>
 )
}

export default OrderStatus;